import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { EmailHeadComponent } from '../email-head/email-head.component';
import { SearchService } from '@modules/search/services/search.service';
import { TooltipModule } from 'primeng/tooltip';
import { InputSwitchModule } from 'primeng/inputswitch';
import { FormsModule } from '@angular/forms';
import { EmlViewComponent } from '../eml-view/eml-view.component';
import { AccordionModule } from 'primeng/accordion';
import { PaginatorModule } from 'primeng/paginator';
import { Toolbar } from '@modules/search/interfaces/interface';
import { ButtonModule } from 'primeng/button';
import { SummarizeChatComponent } from '../../../../shared/components/summarize-chat/summarize-chat.component';
import {
  ActionsService,
  selection,
} from '@modules/search/services/actions.service';
import { SkeletonModule } from 'primeng/skeleton';
import { AttachmentViewComponent } from '../attachment-view/attachment-view.component';
import { AuthService } from '@core/services/auth/auth.service';
import { CommentsComponent } from '../comments/comments.component';
import { ExtractionsService } from '@modules/extractions/extractions.service';
import { ExtractionDetailComponent } from '../../../../../extractions/components/extraction-detail/extraction-detail.component';
import { Extraction } from '@modules/extractions/extraction.interface';
import { ProjectService } from '@core/services/project/project.service';
import { MessageService } from 'primeng/api';
import { SplitterModule } from 'primeng/splitter';

@Component({
  selector: 'app-email-view',
  standalone: true,
  imports: [
    EmailHeadComponent,
    TooltipModule,
    InputSwitchModule,
    FormsModule,
    EmlViewComponent,
    AccordionModule,
    PaginatorModule,
    ButtonModule,
    SummarizeChatComponent,
    SkeletonModule,
    AttachmentViewComponent,
    CommentsComponent,
    ExtractionDetailComponent,
    SplitterModule,
  ],
  templateUrl: './email-view.component.html',
  styleUrls: ['./email-view.component.scss'],
})
export class EmailViewComponent implements OnChanges {
  @Input() data: any;
  @Input() emlHtml: any;
  @Input() isNewTab: boolean = false;
  isLoading: boolean = false;
  emailContent: any;
  toolbar!: Toolbar[];
  winNum = 1;
  showEmailChat: boolean = false;
  isEmailAPIView: boolean = true;
  timerRef: any;
  constructor(
    private _search: SearchService,
    protected _action: ActionsService,
    private _auth: AuthService,
    protected _extraction: ExtractionsService,
    private _project: ProjectService,
    private message: MessageService
  ) {}

  @ViewChild('emailViewBody', { static: true }) emailViewBody: any;
  emailViewBodyHeight: string = '100%';

  subscription: any[] = [];
  selection: selection = {} as selection;
  isChanged: boolean = false;
  ngOnChanges(changes: SimpleChanges): void {
    this.subscription.forEach((sub) => {
      sub.unsubscribe();
    });
    clearTimeout(this.timerRef);
    this.toolbar = [
      {
        label: 'Download',
        icon: 'pi pi-download',
        iconStyle: 'font-size: 0.9rem !important',
        isHidden: !this._project.currentProject().isAllowDownload,
        command: () => {
          this._action.downloadFile(this.data);
        },
      },
      {
        label: 'Share Document',
        icon: 'pi pi-share-alt',
        isHidden: this.isNewTab,
        command: () => {
          this._action.shareDocument(this.data);
        },
      },
      {
        label: 'Comments',
        icon: 'pi pi-comments',
        badgeValue: this.data._source.comments
          ? this.data._source.comments.length
          : 0,
        command: () => {
          //scroll to bottom
          setTimeout(() => {
            const element = document.getElementById('comment-section');
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' });
            }
          }, 100);
        },
      },
      {
        label: 'Manage Labels',
        icon: 'pi pi-tags',
        isHidden: this.isNewTab,
        iconStyle: 'font-size: 1.1rem !important',
        command: () => {
          this._action.manageLabels(this.data, 'search');
        },
      },
      {
        label: 'Extracted Entities',
        icon: 'svg-extraction',
        isHidden: !this._project.currentProject().isSearchShowExtractions,
        command: () => {
          if (!this._extraction.selectedExtractionForSearch._id) {
            this.message.add({
              severity: 'warn',
              summary: 'No Extraction Found',
              detail: 'Please try again later',
              key: 'tr',
            });
            return;
          }
          this.emailViewBodyHeight =
            this.emailViewBody.nativeElement.scrollHeight - 150 + 'px';
          this._action.isShowExtractedEntity =
            !this._action.isShowExtractedEntity;
        },
      },
      {
        label: 'Info',
        icon: 'pi pi-info-circle',
        iconStyle: 'font-size: 1.1rem !important',
        command: () => {},
      },
      {
        label: 'Open in new window',
        icon: 'pi pi-external-link',
        isHidden: this.isNewTab,
        iconStyle: 'font-size: 0.9rem !important',
        command: () => {
          localStorage.setItem('newTabData', JSON.stringify(this.data));
          localStorage.setItem(
            'currentProject',
            JSON.stringify(this._project.currentProject())
          );
          let win = 'tab' + this.winNum;
          this.winNum++;
          window.open('/document', '_blank');
        },
      },
    ];
    clearTimeout(this.timerRef);
    this.markEmailAsViewed();
    this.isChanged = true;
    setTimeout(() => {
      this.isChanged = false;
    }, 1);

    if (this.data) {
      this.showEmailChat = false;
      this.selection = {} as selection;
      this.subscription[0] = this._action.askCopySelection.subscribe((data) => {
        if (data) {
          this.selection = data;
          this.showEmailChat = true;
        }
      });
      if (
        this._auth
          .appConfig()
          .blockEMLViewForProjects?.includes(
            this._project.currentProject().name
          )
      ) {
        this.isLoading = false;
        this.isEmailAPIView = false;
      } else {
        this.isEmailAPIView = true;
        this.getEmlHtml();
      }
      if (this.data._source.content_html) {
        this.emailContent = this.data._source.content_html;
      } else {
        this.emailContent = this.data._source.content;
      }
      if (
        this.data &&
        this.data._source &&
        this.data._source.MD5 &&
        this._project.currentProject().isSearchShowExtractions
      ) {
        this._extraction.getExtractionByMD5(this.data._source.MD5);
      }
    }
  }

  ngOnDestroy() {
    clearTimeout(this.timerRef);
    this.subscription.forEach((sub) => {
      sub.unsubscribe();
    });
  }

  markEmailAsViewed() {
    this.timerRef = setTimeout(() => {
      this.subscription[1] = this._search
        .markEmailAsRead({
          id: this.data._id,
          index: this.data._index,
        })
        .subscribe({
          next: (res) => {
            if (!this._auth.userDetail().email) {
              this._auth.getUserDetails().subscribe({
                next: (res) => {
                  this.data._source['readHistory'] = {
                    ...this.data._source['readHistory'],
                    [res.email]: [],
                  };
                },
                error: (err) => {
                  console.log(err);
                },
              });
            } else {
              this.data._source['readHistory'] = {
                ...this.data._source['readHistory'],
                [this._auth.userDetail().email]: [],
              };
            }
          },
          error: (err) => {
            console.log(err);
          },
        });
    }, 10000);
  }

  private getEmlHtml() {
    this.isLoading = true;
    let params = {
      filePath: this.data._source.filePath,
    };
    this.subscription[2] = this._search.getEmlToHtml(params).subscribe({
      next: (response) => {
        this.emlHtml = response;
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
      },
    });
  }

  closeExtractionDetails() {
    this._extraction.isEditEntities = false;
    this._action.isShowExtractedEntity = false;
  }
}
